export function normalizeYaw(yaw: number) {
  const turn = Math.PI * 2;
  return ((yaw + Math.PI) % turn + turn) % turn - Math.PI;
}
// Imported headings may be 0..2PI; normalize before replay quantization.
export function packedYaw(yaw: number) {
  return Math.max(-Math.PI, Math.min(Math.PI, Math.round(normalizeYaw(yaw) * 1e5) / 1e5));
}
